// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import FullscreenProvider from './FullscreenProvider';

export { useFullscreenContext } from '../../hooks/useFullscreenContext';
export type { ExtendedFullScreenHandle } from './FullscreenProvider';

export default FullscreenProvider;
